import React from 'react';
import { OliveTreeLogo, DecorativeBorder, SunMotif } from './DecorativeElements';
export function Hero() {
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center p-8 overflow-hidden bg-paper-texture" data-id="element-268">
      {/* Decorative Corners */}
      <div className="absolute top-0 left-0 w-32 h-32 opacity-20 pointer-events-none" data-id="element-269">
        <SunMotif className="w-full h-full text-[var(--sienna)] -translate-x-1/2 -translate-y-1/2" data-id="element-270" />
      </div>
      <div className="absolute bottom-0 right-0 w-48 h-48 opacity-10 pointer-events-none rotate-180" data-id="element-271">
        <SunMotif className="w-full h-full text-[var(--sienna)] translate-x-1/3 translate-y-1/3" data-id="element-272" />
      </div>

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-273">
        <div className="mb-8 animate-fade-in" data-id="element-274">
          <OliveTreeLogo className="w-48 h-48 md:w-64 md:h-64 mx-auto" data-id="element-275" />
        </div>

        <h1 className="flex flex-col items-center mb-6" data-id="element-276">
          <span className="text-6xl md:text-8xl font-bold text-[var(--brown)] tracking-tight mb-2" data-id="element-277">
            WACA
          </span>
          <span className="font-script text-4xl md:text-6xl text-[var(--sienna)] -mt-4 transform -rotate-2" data-id="element-278">
            Apulian Villa
          </span>
        </h1>

        <div className="w-full max-w-md my-6" data-id="element-279">
          <DecorativeBorder className="w-full h-4 text-[var(--sage)]" data-id="element-280" />
        </div>

        <p className="text-xl md:text-2xl text-[var(--brown)] max-w-2xl leading-relaxed italic" data-id="element-281">
          "Benvenuti a casa." <br data-id="element-282" />
          <span className="text-lg md:text-xl not-italic opacity-80 mt-2 block font-serif" data-id="element-283">
            Experience the slow rhythm of the Italian countryside.
          </span>
        </p>

        <div className="mt-12" data-id="element-284">
          <div className="animate-bounce-slow" data-id="element-285">
            <svg className="w-6 h-6 text-[var(--sienna)]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-286">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-287" />
            </svg>
          </div>
        </div>
      </div>
    </section>;
}